<template>
  <gf-button-subscribe
    :stars-count="parseInt(starsCount)"
    :is-starred="isStarred"
    @star="starProject"
  ></gf-button-subscribe>
</template>

<script>
import GfButtonSubscribe from '@shared/shared-components/shared/components/GfButtonSubscribe';
import ProjectService from '@/shared-modules/modules/project/project.service';

export default {
  name: 'GfButtonProjectSubscribe',
  components: { GfButtonSubscribe },
  props: {
    alias: {
      type: String,
      default: null,
      required: true
    },
    projectAlias: {
      type: String,
      default: null,
      required: true
    },
    starsCount: {
      default: 0
    },
    starred: {
      default: false
    }
  },
  computed: {
    isStarred() {
      return this.starred === true || this.starred === 'true';
    },
    isUserAuthtorized() {
      return this.$store.getters.getIsUserAuthtorized;
    }
  },
  methods: {
    starProject(data) {
      if (this.isUserAuthtorized) {
        ProjectService.starProject(this.alias, this.projectAlias, {
          starred: data
        });
      } else {
        window.location = '/auth/login';
      }
    }
  }
};
</script>

<style lang="scss"></style>
